import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import './style.css';
import logo from '../../../images/login-logo@1x.png';
import { connect } from 'react-redux';
import { login, clearError, logout } from './ducks/actions';
import { Alert, Row, Col, ControlLabel } from 'react-bootstrap';
import ForgotUsername from '../ForgotUsername';
import ForgotPassword from '../ForgotPassword';
export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      secret: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  handleDismiss() {
    this.props.actions.clearError();
  }

  handleSubmit(event) {
    this.props.actions.login(this.state.username, this.state.secret);
    // var history = createBrowserHistory();
    // history.push('/paystubs');
    event.preventDefault();
  }
  componentWillMount() {
    if (this.props.match.url === '/logout') {
      this.props.actions.logout();
    }
  }

  render() {
    if (this.props.token && this.props.match.url !== '/logout') {
      return <Redirect to="/paystubs" />;
    } else if (!this.props.token && this.props.match.url === '/logout') {
      return <Redirect to="/" />;
    }

    var errorMessage;
    if (this.props.error) {
      errorMessage = (
        <Row>
          <Col xs={12}>
            <Alert bsStyle="danger" onDismiss={this.handleDismiss}>
              {this.props.error}
            </Alert>
          </Col>
        </Row>
      );
    }
    return (
      <div className="main-wrapper">
        <form onSubmit={this.handleSubmit} className="panel panel-default">
          <div className="panel-heading">
            <img src={logo} alt="ComputerEase" />
            <h3 className="panel-title">Employee Hub</h3>
          </div>
          <div className="panel-body">
            {errorMessage}
            <Row>
              <Col xs={12} className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-user-circle" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Username"
                    type="text"
                    name="username"
                    value={this.state.username}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-lock" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Password"
                    type="password"
                    name="secret"
                    value={this.state.secret}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <input
                  className="btn btn-lg btn-primary btn-block"
                  type="submit"
                  value="Login"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="text-center">
                <ForgotUsername /> | <ForgotPassword />
              </Col>
            </Row>
          </div>
        </form>
        <p className="small footer-notes">
          <strong>
            Copyright © {new Date().getFullYear()} Deltek, Inc.<br />All rights
            reserved.<br />
            <a
              href="https://www.deltek.com/en/legal.aspx"
              target="privacy_policy"
              class="white"
            >
              Privacy Policy
            </a>
          </strong>
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.loginReducer.error,
    token: state.loginReducer.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      login: (username, secret) => {
        dispatch(login(username, secret));
      },
      logout: () => {
        dispatch(logout());
      },
      clearError: () => {
        dispatch(clearError());
      }
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/components/account/Login/index.js